<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" @dialogChange="dialogDataChange"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" @dialogChange="dialogDataChange"></router-view>
    <foot @dialogChange="dialogDataChange"/>
    <dialogMask v-show="isShowDialog" :dialog-data="dialogData" @dialogClose="dialogClose" />
    <miniAudio @dialogChange="dialogDataChange"/>
  </div>
</template>

<script>
import foot from './components/footer.vue';
import dialogMask from './components/dialog.vue';
import miniAudio from './components/miniAudio.vue';

export default {
  name: 'app',
  data() {
    return {
      dialogData: {},
      isShowDialog: false,
    }
  },
  created() {
    
  },
  components: {
    foot,
    dialogMask,
    miniAudio
  },
  methods: {
    dialogDataChange(data) {
      let that = this;
      that.dialogData = data;
      that.isShowDialog = true;
    },
    dialogClose() {
      let that = this;
      that.isShowDialog = false;
    }
  }
}
</script>

<style>

#app {
  /* font-family: 'Avenir', Helvetica, Arial, sans-serif; */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
